'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.createApi = createApi;
const server_1 = require('./server');
const runtime_1 = require('./runtime');
const cross_fetch_1 = require('cross-fetch');
function createApi(type, options = {}) {
    var _a, _b, _c;
    const {
        server: basePath = server_1.Server.Sandbox,
        auth,
        username = '',
        password = '',
        accessToken = '',
        fetchApi = cross_fetch_1.default,
    } = options;
    const config = Object.assign(
        Object.assign(
            {
                fetchApi,
                basePath,
            },
            (_a =
                options === null || options === void 0
                    ? void 0
                    : options.config) !== null && _a !== void 0
                ? _a
                : {}
        ),
        {
            headers: Object.assign(
                { accept: 'application/json' },
                (_c =
                    (_b =
                        options === null || options === void 0
                            ? void 0
                            : options.config) === null || _b === void 0
                        ? void 0
                        : _b.headers) !== null && _c !== void 0
                    ? _c
                    : {}
            ),
        }
    );
    if (auth === 'basic') {
        config.username = username;
        config.password = password;
    } else if (auth === 'bearer') {
        config.accessToken = accessToken;
    }
    return new type(new runtime_1.Configuration(config));
}
